export default "__VITE_ASSET__DZ3pa8ky__"